import { useState, useRef } from "react"
import { useSearchParams } from "react-router-dom"

import Style from "./style"
import defaultProfile from "./asset/default_profile.svg"
import editImage from "./asset/edit_image.svg"

import DefaultInput from "shared/ui/DefaultInput"
import DefaultButton from "shared/ui/DefaultButton"
import ContactInput from "widget/ContactInput"
import AgreeModal from "widget/AgreeModal"

import personalTerm from "shared/constant/term/personalTerm"
import serviceTerm from "shared/constant/term/serviceTerm"

import usePostAuthSnsSignup from "entity/auth/usePostAuthSnsSignup"
import usePostUtilUpload from "entity/util/usePostUtilUpload"

const SignupSns = () => {
    const [searchParams] = useSearchParams()
    const snsType = searchParams.get("type")

    const nameRef = useRef()
    const nicknameRef = useRef()
    const countryCodeRef = useRef()
    const contactRef = useRef()

    const inputFileRef = useRef()
    const uploadedPathRef = useRef()
    const profileImgRef = useRef()

    const [isModalShow, setIsModalShow] = useState(false)

    const [uploadPath, changeFileEvent] = usePostUtilUpload(profileImgRef, uploadedPathRef)
    const [postSignup] = usePostAuthSnsSignup(nameRef, nicknameRef)

    const tmpTerm = [
        {
            "title": "서비스 이용 약관 (필수)",
            "content": serviceTerm
        },
        {
            "title": "개인정보 수집과 이용 동의 (필수)",
            "content": personalTerm
        },
    ]

    const signupEvent = () => {
        setIsModalShow(false)
        postSignup(uploadPath)
    }

    return (
        <>
            {isModalShow && <AgreeModal
                title="회원가입 약관 동의" closeEvent={() => setIsModalShow(false)}
                list={tmpTerm}
                buttonLabel="회원가입 마무리하기" clickEvent={signupEvent} />
            }

            <Style.Wrapper>
                <Style.Title>SIGN UP</Style.Title>

                <Style.SignupForm>

                    {snsType !== "apple" &&
                        <DefaultInput title="이름" required placeholder="10자 이하" hint={`영문과 한글만 입력해주세요.\n신분증 상 이름과 동일하게 입력해 주세요.`} inputRef={nameRef} />
                    }
                    <DefaultInput title="닉네임" required placeholder="20자 이하" inputRef={nicknameRef} />

                    <ContactInput countryCodeRef={countryCodeRef} contactRef={contactRef} />

                    <Style.ProfileImgDiv>
                        <h2>프로필 이미지</h2>
                        <button onClick={() => inputFileRef.current.click()}>
                            <input type="file" ref={inputFileRef} onChange={changeFileEvent} style={{ display: "none" }} />
                            <Style.ProfileImg src={uploadPath || defaultProfile} ref={profileImgRef} />
                            <Style.ProfileOption src={editImage} />
                        </button>
                        <p>jpg, png 이미지 / 20mb 이하</p>
                    </Style.ProfileImgDiv>

                </Style.SignupForm>

                <Style.SignupButtonDiv>
                    <DefaultButton clickEvent={() => setIsModalShow(true)}>회원가입</DefaultButton>
                </Style.SignupButtonDiv>

            </Style.Wrapper>
        </>
    )
}

export default SignupSns